import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { userService } from '../services/api';

const TRADUCCIONES = {
  // Nav / Header
  contenidos:      { es: 'Contenidos',       en: 'Content',         pt: 'Conteúdos' },
  panel_admin:     { es: 'Panel Admin',      en: 'Admin Panel',     pt: 'Painel Admin' },
  cerrar_sesion:   { es: 'Cerrar Sesión',    en: 'Log Out',         pt: 'Sair' },
  iniciar_sesion:  { es: 'Iniciar Sesión',   en: 'Log In',          pt: 'Entrar' },
  registrarse:     { es: 'Registrarse',      en: 'Register',        pt: 'Registrar-se' },
  entrenamiento_wa:{ es: 'Entrenamiento WA', en: 'WA Training',     pt: 'Treinamento WA' },

  // DocumentosPage
  centro_contenidos:   { es: 'Centro de Contenidos',    en: 'Content Center',        pt: 'Central de Conteúdos' },
  selecciona_tema:     { es: 'Selecciona un tema para iniciar una consulta interactiva.', en: 'Select a topic to start an interactive consultation.', pt: 'Selecione um tema para iniciar uma consulta interativa.' },
  no_contenidos:       { es: 'No hay contenidos disponibles.', en: 'No content available.', pt: 'Nenhum conteúdo disponível.' },
  cargando_contenidos: { es: 'Cargando contenidos...', en: 'Loading content...', pt: 'Carregando conteúdos...' },
  consultar:           { es: 'Consultar',    en: 'Consult',         pt: 'Consultar' },
  mentor:              { es: 'Mentor',       en: 'Mentor',          pt: 'Mentor' },
  preguntas:           { es: 'Preguntas',    en: 'Questions',       pt: 'Perguntas' },
  intentos:            { es: 'Intentos',     en: 'Attempts',        pt: 'Tentativas' },
  certificado:         { es: 'Certificado',  en: 'Certificate',     pt: 'Certificado' },
  todos:               { es: 'Todos',        en: 'All',             pt: 'Todos' },
  filtrar_idioma:      { es: 'Idioma',       en: 'Language',        pt: 'Idioma' },

  // Login / Register
  email:           { es: 'Correo electrónico', en: 'Email',           pt: 'E-mail' },
  contrasena:      { es: 'Contraseña',         en: 'Password',        pt: 'Senha' },
  nombre:          { es: 'Nombre completo',    en: 'Full name',       pt: 'Nome completo' },
  bienvenido:      { es: 'Bienvenido',         en: 'Welcome',         pt: 'Bem-vindo' },
};

const IdiomaContext = createContext();

export const IdiomaProvider = ({ children, userIdioma }) => {
  const [idioma, setIdiomaState] = useState(() => {
    return userIdioma || localStorage.getItem('idioma_preferido') || 'es';
  });

  // Sync when user idioma changes (login/logout)
  useEffect(() => {
    if (userIdioma) {
      setIdiomaState(userIdioma);
      localStorage.setItem('idioma_preferido', userIdioma);
    }
  }, [userIdioma]);

  const t = useCallback((key) => {
    const entry = TRADUCCIONES[key];
    if (!entry) return key;
    return entry[idioma] || entry['es'] || key;
  }, [idioma]);

  const setIdioma = useCallback((lang) => {
    setIdiomaState(lang);
    localStorage.setItem('idioma_preferido', lang);
    // Persist to backend (fire & forget)
    userService.updateIdioma(lang).catch(() => {});
  }, []);

  return (
    <IdiomaContext.Provider value={{ idioma, setIdioma, t }}>
      {children}
    </IdiomaContext.Provider>
  );
};

export const useIdioma = () => {
  const ctx = useContext(IdiomaContext);
  if (!ctx) throw new Error('useIdioma must be used within IdiomaProvider');
  return ctx;
};

export default IdiomaContext;
